import React from 'react';

import { useLocation } from 'react-router';
import { useQuery } from '@apollo/client';

import Cover from './components/printer/catalogpages/Cover';
import AboutUsPage from './components/printer/catalogpages/AboutUsPage';
import ProductPages from './components/printer/catalogpages/ProductPages';
import FeaturedProducts from './components/printer/catalogpages/FeaturedProducts';

import GET_CATALOG from '../../../commons/gql/remote/catalogs/GetCatalog';

const useQueryParams = () => new URLSearchParams(useLocation().search);

const Catalog = () => {
  const queryParams = useQueryParams();
  const catalogSpecId = queryParams.get('catalogSpecId');
  const pricesheetId = queryParams.get('pricesheetId');
  const { loading, data } = useQuery(GET_CATALOG, {
    variables: {
      catalogSpecId,
      pricesheetId,
    },
  });
  if (loading) return <div />;
  if (data === undefined) return <div>No catalog or pricesheet found...</div>;

  const {
    name, sections, coverWords, featuredProducts,
  } = data?.catalog;

  const startPage = 3;
  const coverWords2 = ['salchichas carmela', 'café lareño', 'adobochón', 'malta india', 'inruta'];
  return (
    <div>
      <Cover coverTitle={name} coverWords={coverWords ?? coverWords2} />
      <AboutUsPage />
      <FeaturedProducts
        pageNumber={startPage + 1}
        products={featuredProducts}
      />
      <ProductPages sections={sections} startPage={startPage + 2} />
    </div>
  );
};

export default Catalog;
